//通用js

export let getClassActive = (list,classId) => {
    if(list&&list.length>0){
        for(let i=0,len = list.length;i<len;i++){
            if(list[i].id == classId){
                return i;
            }
        }
    }
    return 0;
}



// WEBPACK FOOTER //
// ./src/assets/js/core.js